module.exports = __webpack_public_path__ + "img/2.53acc947.png";